// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1bk7o","left":"StickyBox_left__1H_s4","right":"StickyBox_right__1z0db"};